import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  ExtractMaterialPurchaseDataFromReceiptDocumentInput,
  ExtractMaterialPurchaseDataFromReceiptDocumentMutation,
} from '@/gql/graphql';

const EXTRACT_MATERIAL_PURCHASE_DATA_FROM_RECEIPT_DOCUMENT_MUTATION = graphql(`
  mutation ExtractMaterialPurchaseDataFromReceiptDocument(
    $input: ExtractMaterialPurchaseDataFromReceiptDocumentInput!
  ) {
    extractMaterialPurchaseDataFromReceiptDocument(input: $input) {
      supplier {
        new {
          name
        }
        existing {
          id
          name
        }
      }
      materialPurchases {
        quantity
        taxPercentage
        unitPrice {
          value
          currency {
            code
            exponent
          }
        }
        material {
          new {
            name
          }
        }
      }
    }
  }
`);

type MaterialPurchaseDataFromReceiptDocument =
  ExtractMaterialPurchaseDataFromReceiptDocumentMutation['extractMaterialPurchaseDataFromReceiptDocument'];

const useExtractMaterialPurchaseDataFromReceiptDocument = (
  options?: UseMutationOptions<
    ExtractMaterialPurchaseDataFromReceiptDocumentMutation,
    unknown,
    ExtractMaterialPurchaseDataFromReceiptDocumentInput
  >
) => {
  return useMutation({
    mutationFn: (
      input: ExtractMaterialPurchaseDataFromReceiptDocumentInput
    ) => {
      return gqlClient.request(
        EXTRACT_MATERIAL_PURCHASE_DATA_FROM_RECEIPT_DOCUMENT_MUTATION,
        {
          input,
        }
      );
    },
    ...options,
  });
};

export default useExtractMaterialPurchaseDataFromReceiptDocument;
